import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function IspIntroNode(props) {
    return <NodeWithMultipleHandles {...props} nodeType="isp_intro" />;
}
